import {
  ContentCopyEnum,
  ContentLogoEnum,
  ContentPhotosEnum,
  type ContentCopy,
  type ContentLogo,
  type ContentPhotos,
} from '@flashpoint/site-dna';
import type { StepProps } from '../stepProps';

export function ContentStep({ lead, queueField }: StepProps) {
  const c = lead.content;
  return (
    <div className="space-y-6">
      <RadioGroup
        label="Copy"
        value={c.copy}
        options={ContentCopyEnum.options}
        onChange={(v) => queueField('content.copy', v as ContentCopy)}
      />
      <RadioGroup
        label="Photos"
        value={c.photos}
        options={ContentPhotosEnum.options}
        onChange={(v) => queueField('content.photos', v as ContentPhotos)}
      />
      <RadioGroup
        label="Logo"
        value={c.logo}
        options={ContentLogoEnum.options}
        onChange={(v) => queueField('content.logo', v as ContentLogo)}
      />
    </div>
  );
}

interface RadioGroupProps {
  label: string;
  value: string;
  options: readonly string[];
  onChange: (next: string) => void;
}

function RadioGroup({ label, value, options, onChange }: RadioGroupProps) {
  return (
    <div>
      <div className="mb-2 text-[11px] uppercase tracking-widest text-nm-muted">{label}</div>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const selected = value === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onChange(opt)}
              className={`rounded-lg border px-3 py-2 text-sm font-medium transition ${
                selected
                  ? 'border-flashpoint-ember bg-nm-surface text-nm-ink'
                  : 'border-nm-border bg-nm-moss/30 text-nm-ink hover:border-nm-muted'
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}
